import React from "react";
import axios from "axios";
import join from 'url-join';
// import https from "https";
// const https = require('https');
import authenService from '../utils/services/authenService';
import { store } from '../utils/redux/store';
import _ from 'lodash'
import jwt_decode from 'jwt-decode'
import { login } from '../utils/redux/actions/authenAction';

//const auth = 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJYZ202OEN4S05EcHVkM1lQVmdwdF9jV19YLWc1SG1VaFBER0ZIZGxOQWZnIn0.eyJleHAiOjE2OTE2MTA5OTQsImlhdCI6MTY5MTYwOTc5NCwianRpIjoiMzM2MTlmODItOTgyNS00NWZmLThlZTktNTQ5NmYwZDdhZWM4IiwiaXNzIjoiaHR0cDovLzE4LjEzOS4xOTMuMTEwOjMwMDAxL2F1dGgvcmVhbG1zL21hc3RlciIsImF1ZCI6ImFjY291bnQiLCJzdWIiOiI5Y2YwMTRhNy1mMTg0LTRiNzgtOTBmZC0zYzI2NTNkNzNiMGQiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJsb29wLW1lcmNoYW50Iiwic2Vzc2lvbl9zdGF0ZSI6Ijk4ZDBhMGM2LTEyN2ItNDkwNi1iMzliLWZkOWZjYTljZWZjNCIsImFjciI6IjEiLCJhbGxvd2VkLW9yaWdpbnMiOlsiKiJdLCJyZWFsbV9hY2Nlc3MiOnsicm9sZXMiOlsiZGVmYXVsdC1yb2xlcy1tYXN0ZXIiLCJvZmZsaW5lX2FjY2VzcyIsInVtYV9hdXRob3JpemF0aW9uIl19LCJyZXNvdXJjZV9hY2Nlc3MiOnsiYWNjb3VudCI6eyJyb2xlcyI6WyJtYW5hZ2UtYWNjb3VudCIsIm1hbmFnZS1hY2NvdW50LWxpbmtzIiwidmlldy1wcm9maWxlIl19fSwic2NvcGUiOiJwcm9maWxlIGVtYWlsIiwic2lkIjoiOThkMGEwYzYtMTI3Yi00OTA2LWIzOWItZmQ5ZmNhOWNlZmM0IiwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJuYW1lIjoi4LiK4LmJ4Liy4LiHIiwicHJlZmVycmVkX3VzZXJuYW1lIjoiMTIzNDU2Nzg5MCIsImdpdmVuX25hbWUiOiLguIrguYnguLLguIciLCJlbWFpbCI6InBvcEBwb3AuYWMifQ.eFe-1JpxC0mmnChqwBVUsxBZpIXsgh2WA6m6azP9nd3fA8B3JvGGeoV9obl1_HlTMezWtP40qCnYdoA7OxvWsBZGq-THKAHGL2ih-SJs_H3gB7PMIMgXyWGt-YhKuxV3xAuU2iqnoEtcs2Tw1FuR-QFQRz0PgaCDxbPewuuMz6nv5RCJl_rfTNL8BBQGg0nPPipe-32F_3WOkZjJvsmEd7LdTiyzdOfL_ZerqdY9RmkiXgM62zLL64q5W5a_3a-E3wYzUX932nuqkBuRcbtiL-5m_jnl4OAaddvmEQ9kXc9rQGsH8h5vqlrVZn6raQfadQ6QyencoR0dJ5NZWA5ctw';
const instanceImg = axios.create()
let isAbsoluteURLRegex = /^(?:\w+:)\/\//;


instanceImg.interceptors.request.use(async (config) => {
  const states = store.getState();
  const _authenService = new authenService();
  let accessToken = states.authenReducer.accessToken;
  const refreshToken = states.authenReducer.refreshToken;
  const accessTokenExp = states.authenReducer.tokenExpire;
  const username = states.authenReducer.username;
  const password = states.authenReducer.password;
  const d1 = new Date();
  const d2 = new Date(accessTokenExp * 1000);
  // //console.log('axios d1 ', d1);
  // //console.log('axios d2 ', d2);
  if (d2 < d1) {
    const result = await _authenService.refreshToken(refreshToken)
    const response = _.get(result, 'data')
    const decoded = jwt_decode(response.access_token);
    store.dispatch(
      login(
        response.access_token,
        response.expires_in,
        response.refresh_expires_in,
        response.refresh_token,
        response.token_type,
        response.session_state,
        response.scope,
        decoded.sub,
        decoded.exp,
        username,
        password
      )
    )
    accessToken = response.access_token
  }

  const auth = accessToken;
  var url = `${process.env.REACT_APP_BASE_URL}`;
  var port = ``;

  if (!isAbsoluteURLRegex.test(config.url)) {
    if (config.url.indexOf('/v3/business-partner/manager/') !== -1) {
      port = `${process.env.REACT_APP_BUSINESS_PARTNER_MANAGER_PORT}`;
    }
    else if (config.url.indexOf('/v5/business-partner/manager/company/') !== -1) {
      port = `${process.env.REACT_APP_BUSINESS_PARTNER_MANAGER_PORT}`;
    }
  }

  // baseURL: `${process.env.REACT_APP_BASE_URL}:${process.env.REACT_APP_BUSINESS_PARTNER_MANAGER_PORT}`, 
  config.url = join(`${url}:${port}`, config.url);
  config.headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Max-Age': '86400',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Headers': 'Content-Type',
    'Content-Type': 'multipart/form-data',
    Authorization: 'Bearer ' + auth,
  }

  return config

});


export { instanceImg }